import { FC, useState } from 'react';
import styles from './CopyToClipboardButton.module.scss';
import { ReactComponent as COPY } from 'assets/img/copy.svg';
import { ReactComponent as COPYDONE } from 'assets/img/copyDone.svg';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';

interface CopyToClipboardButtonTypes {
  content: string;
  onCopy?: () => void;
  width?: number;
  height?: number;
  showNotification?: boolean;
  notificationText?: string;
}

function copyTextToClipboard(text: string) {
  return navigator.clipboard.writeText(text);
}

export const CopyToClipboardButton: FC<CopyToClipboardButtonTypes> = ({
  content,
  onCopy,
  width = 16,
  height = 16,
  showNotification = false,
  notificationText = 'Скопировано в буфер обмена',
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const [showCopiedSuccess, setShowCopiedSuccess] = useState(false);

  const handleCopy = () => {
    copyTextToClipboard(content)
      .then(() => {
        setIsCopied(true);
        if (showNotification) {
          setShowCopiedSuccess(true);
        }
        if (onCopy) {
          onCopy();
        }
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
        setIsCopied(false);
      });
  };

  const svgStyle = {
    width: `${width}px`,
    height: `${height}px`,
  };

  return (
    <>
      <span onClick={handleCopy} className={styles.copyBtn}>
        {isCopied ? <COPYDONE style={svgStyle} /> : <COPY style={svgStyle} />}
      </span>
      {showNotification && showCopiedSuccess && (
        <SuccessErrorInfo
          type='success'
          text={notificationText}
          handleClose={() => setShowCopiedSuccess(false)}
        />
      )}
    </>
  );
};
